// hooks/useWebViewBridge.ts
export const sendMessageToFlutter = ({
  action,
  data,
}: {
  action: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
}) => {
  if (typeof window !== 'undefined' && window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('sendDataToFlutter', JSON.stringify({ action, data }));
  } else {
    console.error('flutter_inappwebview is not available on the window object.');
  }
};

export const useWebViewBridge = () => {
  return {
    sendMessageToFlutter,
  };
};
